import { BOARD_EXPORT_MEDIA, BOARD_EXPORT_MEDIA_RESET } from './exportConstants';

export const notifyBoardExport = ({ boardId, userId, downloadUrl, fileName, sessionId }) => ({
    type: BOARD_EXPORT_MEDIA,
    id: boardId,
    userId,
    downloadUrl,
    fileName,
    sessionId,
});

export const boardExportReset = ({ boardId }) => ({
    type: BOARD_EXPORT_MEDIA_RESET,
    id: boardId,
});
